export default class Form {
	constructor($module) {
		this.$module = $module;
		// Put code here
	}
}

const DEFAULT_MULTI_VALUE_SELECTOR = ".bc-multi-select__input";

export function getMultiValueFieldNames(
	$scope,
	selector = DEFAULT_MULTI_VALUE_SELECTOR
) {
	if (!$scope) {
		return new Set();
	}

	return new Set(
		Array.from($scope.querySelectorAll(selector))
			.map(($input) => $input.name)
			.filter(Boolean)
	);
}

export function getCheckedInputValues(
	$scope,
	selector = DEFAULT_MULTI_VALUE_SELECTOR,
	{ excludeDisabled = false } = {}
) {
	if (!$scope) {
		return [];
	}

	return Array.from($scope.querySelectorAll(selector))
		.filter(($input) => $input.checked && (!excludeDisabled || !$input.disabled))
		.map(($input) => $input.value);
}

export function serializeFormData(formData, multiValueFieldNames = new Set()) {
	const output = {};

	formData.forEach((value, key) => {
		if (multiValueFieldNames.has(key)) {
			if (!Array.isArray(output[key])) {
				output[key] = [];
			}
			output[key].push(value);
			return;
		}

		output[key] = value;
	});

	multiValueFieldNames.forEach((name) => {
		if (!Array.isArray(output[name])) {
			output[name] = [];
		}
	});

	return output;
}

export function shouldSubmitToServer($form) {
	const action = $form?.getAttribute("action");

	return Boolean(action && action.trim() && action.trim() !== "#");
}

export function buildFormSubmissionPayload(
	$form,
	$scope,
	{ multiValueSelector = DEFAULT_MULTI_VALUE_SELECTOR } = {}
) {
	const formData = new FormData($form);
	const multiValueFieldNames = getMultiValueFieldNames($scope, multiValueSelector);
	const values = serializeFormData(formData, multiValueFieldNames);
	const multiSelectValues = getCheckedInputValues($scope, multiValueSelector);

	return {
		formData,
		values,
		multiSelectValues
	};
}
